import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _get from "lodash/get";

var _templateObject;

import styled, { css } from 'styled-components';
import { media } from '@luigiclaudio/ga-baseline-ui/layout';
import mailchimpSignUpTheme from '../../styles/mailchimpSignUpTheme';
var FeatureContainer = styled.article.withConfig({
  displayName: "FeatureContainer",
  componentId: "sc-1xqu41n-0"
})(["padding-bottom:", "vh;padding-top:", "vh;", " ", ""], function (_ref) {
  var verticalSpacing = _ref.verticalSpacing;
  return verticalSpacing / 2;
}, function (_ref2) {
  var verticalSpacing = _ref2.verticalSpacing;
  return verticalSpacing / 2;
}, media.sm(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n        padding-bottom: ", "vh;\n        padding-top: ", "vh;\n    "])), function (_ref3) {
  var verticalSpacing = _ref3.verticalSpacing;
  return verticalSpacing;
}, function (_ref4) {
  var verticalSpacing = _ref4.verticalSpacing;
  return verticalSpacing;
}), function (_ref5) {
  var showDivider = _ref5.showDivider,
      theme = _ref5.theme;
  return showDivider && css(["border-top:1px solid ", ";"], _get(theme, 'mailchimpSignUp.feature.divider.color', mailchimpSignUpTheme.mailchimpSignUp.feature.divider.color));
});
export default FeatureContainer;